import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

import { PLACEMENT_PERKS } from "../types/createPlacement.schema";

export interface PlacementPerk {
  value: string;
  label: string;
  icon?: string;
}

/**
 * Hook to get placement perks from launch darkly. Uses PLACEMENT_PERKS from
 * the previously defined form schema as the default value
 */
export function usePlacementPerks(): PlacementPerk[] {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_PERKS_CONFIGURATION, {
    defaultValue: PLACEMENT_PERKS.map((perk) => ({
      value: perk.value,
      label: perk.label,
      icon: perk.icon,
    })),
  });
}
